import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { toOptions } from 'utils/toOptions';

import ControlledMultiSelect from 'components/shared/ControlledFields/ControlledMultiSelect';

import {
  useGetAccountGroups,
  useGetEmployees
} from '../../../../../../queries';
import { ControlledDatePicker } from '../../../../../shared';

const AuthSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  const { data: employees } = useGetEmployees();
  const { data: group } = useGetAccountGroups();

  return (
    <>
      <ControlledDatePicker
        fullWidth
        variant="outlined"
        control={control}
        name="reference_date"
        label={t('referenceDate')}
      />
      <ControlledMultiSelect
        fullWidth
        name="account_id_list"
        label={t('accountName')}
        variant="outlined"
        options={employees ?? []}
      />
      <ControlledMultiSelect
        fullWidth
        name="group_id_list"
        label={t('groupName')}
        variant="outlined"
        options={toOptions(group ?? [], 'groupId', 'name')}
      />
    </>
  );
};

export default AuthSection;
